import {action, makeAutoObservable, observable} from 'mobx';

class KafkaStore {
    constructor() {
        makeAutoObservable(this);
    }

    /**
     * Захешированный отпечаток браузера
     * @type {String}
     */
    @observable imprintHash = '';

    /**
     * Инициализация захешированного отпечатка браузера
     */
    @action setImprintHash = (imprint) => {
        this.imprintHash = imprint;
    }
}

const LandingKafkaStore = new KafkaStore();

export default LandingKafkaStore;

